import script from "./TinymceEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TinymceEditor.vue?vue&type=script&setup=true&lang=js"

import "./TinymceEditor.vue?vue&type=style&index=0&id=79c413dc&lang=scss&scoped=true"
import "./TinymceEditor.vue?vue&type=style&index=1&id=79c413dc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c413dc"]])

export default __exports__